import React from "react";
import { Col, Row, Input, Select, Radio } from "antd";
import { CountryDropdown } from "react-country-region-selector";
import { Color } from "services";

const { Option } = Select;
const businessTypes = [
  "Private Limited",
  "Proprietorship",
  "Partnership",
  "LLP",
  "Trust",
  "Society",
  "Not Registered",
];

// const strengthTypes = ["1-100", "101-500", "1-500", "500+"];

const formatPan = (val) => {
  let formatted = "";
  for (let i = 0; i < val.length; i++) {
    let char = val[i].toUpperCase();
    let len = formatted.length;
    if (len < 5) {
      if (/[A-Z]/.test(char)) formatted += char;
    } else if (len < 9) {
      if (/[0-9]/.test(char)) formatted += char;
    } else if (len === 9) {
      if (/[A-Z]/.test(char)) formatted += char;
    }
  }
  return formatted;
};

const formatCin = (val) => {
  let formatted = "";
  for (let i = 0; i < val.length; i++) {
    let char = val[i].toUpperCase();
    let len = formatted.length;
    if (len === 0) {
      if (/[A-Z]/.test(char)) formatted += char;
    } else if (len >= 1 && len <= 5) {
      if (/[0-9]/.test(char)) formatted += char;
    } else if (len >= 6 && len <= 7) {
      if (/[A-Z]/.test(char)) formatted += char;
    } else if (len >= 8 && len <= 11) {
      if (/[0-9]/.test(char)) formatted += char;
    } else if (len >= 12 && len <= 14) {
      if (/[A-Z]/.test(char)) formatted += char;
    } else if (len >= 15 && len <= 20) {
      if (/[0-9]/.test(char)) formatted += char;
    }
  }
  return formatted;
};

export const formatGst = (val) => {
  let formatted = "";
  for (let i = 0; i < val.length; i++) {
    let char = val[i].toUpperCase();
    let len = formatted.length;
    if (len < 2) {
      if (/[0-9]/.test(char)) formatted += char;
    } else if (len >= 2 && len <= 6) {
      if (/[A-Z]/.test(char)) formatted += char;
    } else if (len >= 7 && len <= 10) {
      if (/[0-9]/.test(char)) formatted += char;
    } else if (len === 11) {
      if (/[A-Z]/.test(char)) formatted += char;
    } else if (len === 12) {
      if (/[0-9A-Z]/.test(char)) formatted += char;
    } else if (len === 13) {
      if (/[A-Z]/.test(char)) formatted += char;
    } else if (len === 14) {
      if (/[0-9A-Z]/.test(char)) formatted += char;
    }
  }
  return formatted;
};

export const businessInfo = (
  kycDetails,
  handleUpdateDetails,
  validateData,
  handlePinUpdate,
  changeGstAvailability
) => (
  <div style={{ width: "100%" }}>
    <Row className="m-t-20">
      <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
        <div className="text-xs color-black m-b-5 bold-600">
          Institute Name <span style={{ color: Color.red }}>*</span>
        </div>
        <Input
          onChange={(e) => handleUpdateDetails(e.target.value, "name")}
          value={kycDetails.name}
          placeholder="Enter Name of the institute"
          className="radius-5 kyc-input-fields"
          style={{
            background: Color.lightGrey,
            border: "none",
            color: "black",
          }}
          // disabled={
          //   kycDetails.kycStatus === "Submitted" ||
          //   kycDetails.kycStatus === "Approved"
          // }
          disabled={true}
        />
      </Col>
      <Col
        xs={{ span: 24 }}
        md={{ span: 11, offset: 1 }}
        style={{ width: "100%" }}
      >
        <div className="text-xs color-black m-b-5 bold-600">
          Institute Type <span style={{ color: Color.red }}>*</span>
        </div>
        <Select
          value={kycDetails.orgType}
          rows={3}
          className="kyc-input-fields borderLessSelect"
          style={{ width: "100%", height: 50 }}
          onSelect={(val) => handleUpdateDetails(val, "orgType")}
          placeholder="Enter Business Type"
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
          disabled={
            kycDetails.kycStatus === "Submitted" ||
            kycDetails.kycStatus === "Approved"
          }
        // onClear={val => this.pageAddOrgDetail(null, 'orgType')}
        >
          {businessTypes.map((item) => (
            <Option key={item} value={item}>
              {item}
            </Option>
          ))}
        </Select>
      </Col>
    </Row>
    {/* <Col
      xs={{ span: 24 }}
      md={{ span: 11, offset: 1 }}
      style={{ width: "100%" }}
    >
      <div className="text-xs color-black m-b-5 bold-600">Domain URL<span style={{ color: Color.red }}>*</span> </div>
      <Input
        onChange={(e) => handleUpdateDetails(e.target.value, "url")}
        value={kycDetails.url}
        placeholder="Enter Institute Url"
        className="radius-5 kyc-input-fields"
        style={{ background: Color.lightGrey, border: "none" }}
        disabled={true}
      />
    </Col> */}
    {/* <Col
      xs={{ span: 24 }}
      md={{ span: 11, offset: 1 }}
      style={{ width: "100%" }}
    >
      <div className="text-xs color-black m-b-5 bold-600">
        No. of Students <span style={{ color: Color.red }}>*</span>
      </div>
      <Select
        value={kycDetails.noOfStudents}
        rows={3}
        className="kyc-input-fields borderLessSelect"
        style={{ width: "100%", height: 50 }}
        onSelect={(val) => handleUpdateDetails(val, "noOfStudents")}
        placeholder="Enter No of students in the institute"
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
        disabled={true}
      >
        {strengthTypes.map((item) => (
          <Option key={item} value={item}>
            {item}
          </Option>
        ))}
      </Select>
    </Col> */}
    {kycDetails.orgType === "Private Limited" ||
      kycDetails.orgType === "LLP" ||
      kycDetails.orgType === "Trust" ||
      kycDetails.orgType === "Society" ? (
      <Row className="m-t-20">
        <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
          <div className="text-xs color-black m-b-5 bold-600">
            Business PAN <span style={{ color: Color.red }}>*</span>
          </div>
          <Input
            onChange={(e) => {
              let val = formatPan(e.target.value);
              val.length <= 10
                ? handleUpdateDetails(
                  val,
                  "businessPanNo"
                )
                : e.preventDefault();
            }}
            value={kycDetails.businessPanNo}
            placeholder="Enter 10 digit PAN Number of the business"
            className="radius-5 kyc-input-fields"
            onBlur={(e) => validateData(e.target.value, "institute-pan")}
            style={{ background: Color.lightGrey, border: "none" }}
            disabled={
              kycDetails.kycStatus === "Submitted" ||
              kycDetails.kycStatus === "Approved"
            }
          />
          {kycDetails.businessPanNo && kycDetails.institutePanValid === false ? (
            <div className="text-xs red bold-600">Enter a valid PAN number (e.g., ABCDE1234F).</div>
          ) : null}
        </Col>
        <Col
          xs={{ span: 24 }}
          md={{ span: 11, offset: 1 }}
          style={{ width: "100%" }}
        >
          {kycDetails.orgType === "LLP" ? (
            <>
              <div className="text-xs color-black m-b-5 bold-600">
                LLPIN <span style={{ color: Color.red }}>*</span>
              </div>
              <Input
                onChange={(e) =>
                  e.target.value.length > 7
                    ? e.preventDefault()
                    : handleUpdateDetails(
                      e.target.value.toUpperCase().trim(),
                      "llpin"
                    )
                }
                value={kycDetails.llpin}
                placeholder="Enter LLPIN of the institute"
                className="radius-5 kyc-input-fields"
                onBlur={(e) => validateData(e.target.value, "llpin")}
                style={{ background: Color.lightGrey, border: "none" }}
                disabled={
                  kycDetails.kycStatus === "Submitted" ||
                  kycDetails.kycStatus === "Approved"
                }
              />
              {kycDetails.llpin && kycDetails.llpinValid === false ? (
                <div className="text-xs red bold-600">Enter valid LLPIN</div>
              ) : null}
            </>
          ) : kycDetails.orgType === "Private Limited" ? (
            <>
              <div className="text-xs color-black m-b-5 bold-600">
                CIN <span style={{ color: Color.red }}>*</span>
              </div>
              <Input
                onChange={(e) => {
                  let val = formatCin(e.target.value);
                  val.length > 21
                    ? e.preventDefault()
                    : handleUpdateDetails(
                      val,
                      "cin"
                    )
                }}
                value={kycDetails.cin}
                placeholder="Enter 21-character alpha-numeric Corporate Identification Number"
                className="radius-5 kyc-input-fields"
                onBlur={(e) => validateData(e.target.value, "cin")}
                style={{ background: Color.lightGrey, border: "none" }}
                disabled={
                  kycDetails.kycStatus === "Submitted" ||
                  kycDetails.kycStatus === "Approved"
                }
              />
              {kycDetails.cin && kycDetails.cinValid === false ? (
                <div className="text-xs red bold-600">Enter valid CIN</div>
              ) : null}
            </>
          ) : null}
        </Col>
      </Row>
    ) : null}
    <Row className="m-t-20">
      <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
        <div className="text-xs color-black m-b-5 bold-600">
          Authorized Signatory PAN <span style={{ color: Color.red }}>*</span>
        </div>
        <Input
          onBlur={(e) => validateData(e.target.value, "personal-pan")}
          onChange={(e) => {
            let val = formatPan(e.target.value);
            val.length <= 10
              ? handleUpdateDetails(
                val,
                "personalPanNo"
              )
              : e.preventDefault();
          }}
          value={kycDetails.personalPanNo}
          placeholder="Enter 10-character alpha-numeric PAN number of the authorized signatory"
          className="radius-5 kyc-input-fields"
          style={{ background: Color.lightGrey, border: "none" }}
          disabled={
            kycDetails.kycStatus === "Submitted" ||
            kycDetails.kycStatus === "Approved"
          }
        />
        {kycDetails.personalPanNo && kycDetails.personalPanValid === false ? (
          <div className="text-xs red bold-600">Enter a valid PAN number (e.g., ABCDE1234F).</div>
        ) : null}
      </Col>
      <Col
        xs={{ span: 24 }}
        md={{ span: 11, offset: 1 }}
        style={{ width: "100%" }}
      >
        <div className="text-xs color-black m-b-5 bold-600">
          PAN Owner's Name<span style={{ color: Color.red }}>*</span>
        </div>
        <Input
          onChange={(e) =>
            handleUpdateDetails(
              e.target.value.replace(/[^a-zA-Z ]/g, ""),
              "panOwnerName"
            )
          }
          value={kycDetails.panOwnerName}
          placeholder="Enter Name of the authorized signatory as mentioned on the PAN Card"
          className="radius-5 kyc-input-fields"
          style={{ background: Color.lightGrey, border: "none" }}
          disabled={
            kycDetails.kycStatus === "Submitted" ||
            kycDetails.kycStatus === "Approved"
          }
        />
      </Col>
    </Row>
    {kycDetails.orgType !== "Not Registered" ? (
      <Row className="m-t-20">
        <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
          <div className="text-xs color-black m-b-5 bold-600">
            GSTIN <span style={{ color: Color.red }}>*</span>
          </div>
          <div className="r-c-c-c" style={{ height: 50 }}>
            <Radio.Group
              style={
                kycDetails.kycStatus === "Submitted" ||
                  kycDetails.kycStatus === "Approved"
                  ? { cursor: "not-allowed", pointerEvents: "none" }
                  : {}
              }
              //  disabled={kycDetails.kycStatus === "Submitted" || kycDetails.kycStatus === "Approved"}
              onChange={(e) => changeGstAvailability(e)}
              value={kycDetails.gstAvailable}
            >
              <Radio value={true}>We have a GSTIN</Radio>
              <Radio value={false}>We don't have a GSTIN</Radio>
            </Radio.Group>
          </div>
        </Col>
        {kycDetails.gstAvailable ? (
          <Col
            xs={{ span: 24 }}
            md={{ span: 11, offset: 1 }}
            style={{ width: "100%" }}
          >
            <div
              className="text-xs color-black m-b-5 bold-600"
              style={{ height: 10 }}
            ></div>
            <Input
              onChange={(e) => {
                let val = formatGst(e.target.value);

                if (val.length <= 15) {
                  handleUpdateDetails(val, "gstNo");
                  validateData(val, "gst");
                }
              }}
              value={kycDetails.gstNo}
              placeholder="Enter GSTIN number"
              className="radius-5 kyc-input-fields"
              disabled={
                kycDetails.kycStatus === "Submitted" ||
                kycDetails.kycStatus === "Approved"
              }
              style={{ background: Color.lightGrey, border: "none" }}
            />
            {kycDetails.gstNo && kycDetails.gstValid === false && (
              <div className="text-xs red bold-600">Enter a valid GSTIN (e.g., 22ABCDE1234F1Z5).</div>
            )}
          </Col>
        ) : null}
      </Row>
    ) : null}
    <Row className="m-t-20">
      <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
        <div className="text-xs color-black m-b-5 bold-600">
          HSN/SAC
        </div>

        <Input
          onChange={(e) => handleUpdateDetails(e.target.value, "hsn_sac")}
          value={kycDetails.hsn_sac}
          placeholder="Enter HSN/SAC"
          className="radius-5 kyc-input-fields"
          style={{ background: Color.lightGrey, border: "none" }}
          disabled={
            kycDetails.kycStatus === "Submitted" ||
            kycDetails.kycStatus === "Approved"
          }
        />
      </Col>

      <Col xs={{ span: 24 }} md={{ span: 11, offset: 1 }}>
        <div className="text-xs color-black m-b-5 bold-600">
          Building/Locality/Area <span style={{ color: Color.red }}>*</span>
        </div>
        <Input
          onChange={(e) => handleUpdateDetails(e.target.value, "locality")}
          value={kycDetails.locality}
          placeholder="Enter Building/Locality/Area"
          className="radius-5 kyc-input-fields"
          style={{ background: Color.lightGrey, border: "none" }}
          disabled={
            kycDetails.kycStatus === "Submitted" ||
            kycDetails.kycStatus === "Approved"
          }
        />
      </Col>
    </Row>
    <Row className="m-t-20">
      <Col
        xs={{ span: 24 }}
        md={{ span: 12, offset: 0 }}
        style={{ width: "100%" }}
      >
        <div className="text-xs color-black m-b-5 bold-600">
          PIN Code <span style={{ color: Color.red }}>*</span>
        </div>
        <Input
          // onChange={(e) =>
          //   e.target.value.length > 6
          //     ? e.preventDefault()
          //     : handleUpdateDetails(e.target.value, "pincode")
          // }
          onChange={(e) => {
            const val = e.target.value;

            if (val.length <= 6) {
              handleUpdateDetails(val, "pincode");
              validateData(val, "pin");
              if (val.length === 6) {
                handlePinUpdate(e);
              } else {
                handleUpdateDetails("", "city");
                handleUpdateDetails("", "state");
              }
            }
          }}
          value={kycDetails.pincode}
          placeholder="Enter PIN Code"
          type="number"
          className="radius-5 kyc-input-fields"
          style={{ background: Color.lightGrey, border: "none" }}
          onKeyDown={(e) => {
            if (["e", "E", "+", "-", "."].includes(e.key)) {
              e.preventDefault();
            }
          }}
          disabled={
            kycDetails.kycStatus === "Submitted" ||
            kycDetails.kycStatus === "Approved"
          }
        />
        {kycDetails.pincode && kycDetails.pincodeValid === false ? (
          <div className="text-xs red bold-600">Enter valid PINCODE</div>
        ) : null}
      </Col>

      <Col
        xs={{ span: 24 }}
        md={{ span: 11, offset: 1 }}
        style={{ width: "100%" }}
      >
        <div className="text-xs color-black m-b-5 bold-600">
          District <span style={{ color: Color.red }}>*</span>
        </div>
        <Input
          onChange={(e) => handleUpdateDetails(e.target.value, "city")}
          value={kycDetails.city}
          placeholder="Enter District"
          disabled={
            kycDetails.kycStatus === "Submitted" ||
            kycDetails.kycStatus === "Approved"
          }
          className="radius-5 kyc-input-fields"
          style={{ background: Color.lightGrey, border: "none" }}
        />
      </Col>
    </Row>
    <Row className="m-t-20">
      <Col
        xs={{ span: 24 }}
        md={{ span: 12, offset: 0 }}
        style={{ width: "100%" }}
      >
        <div className="text-xs color-black m-b-5 bold-600">
          State <span style={{ color: Color.red }}>*</span>
        </div>
        <Input
          onChange={(e) => handleUpdateDetails(e.target.value, "state")}
          value={kycDetails.state}
          placeholder="Enter State"
          className="radius-5 kyc-input-fields"
          style={{ background: Color.lightGrey, border: "none" }}
          disabled={
            kycDetails.kycStatus === "Submitted" ||
            kycDetails.kycStatus === "Approved"
          }
        />
      </Col>
    </Row>
    <Row className="m-t-20">
      {/* <Col xs={{ span: 24 }} md={{ span: 12, offset: 0 }}>
        <div className="text-xs color-black m-b-5 bold-600">
          Country <span style={{ color: Color.red }}>*</span>
        </div>
        <div
          className="kyc-input-fields"
          style={{ background: Color.lightGrey, padding: "0px 10px" }}
        >
          <CountryDropdown
            style={{
              border: "none",
              background: Color.lightGrey,
              width: "100%",
            }}
            className="kyc-input-fields"
            placeholder="Select Country*"
            value={kycDetails.country}
            onChange={(val) => handleUpdateDetails(val, "country")}
            disabled={
              kycDetails.kycStatus === "Submitted" ||
              kycDetails.kycStatus === "Approved"
            }
          />
        </div>
      </Col> */}
    </Row>
  </div>
);
